import api from "../api";
import {ElMessage} from "element-plus";

export default {
    namespaced: true,
    state: {
        expense: {},
        expenses: {data: [], current_page: 1, total: 0, per_page: 10},
        payments: {data: [], current_page: 1, total: 0, per_page: 10},
        errors: {
            data: {
                errors: {
                    expense_type_id: [],
                    amount: [],
                    effective_date: [],
                    project_id: []
                }
            }
        },
        has_errors: false,
        loading: false,
        dialogVisible: false,
    },
    getters: {
        dialogVisible: state => state.dialogVisible,
        expenses: state => state.expenses,
        expense: state => state.expense,
        errors: state => state.errors,
        has_errors: state => state.has_errors,
        loading: state => state.loading,
        payments: state => state.payments
    },
    mutations: {
        setLoading(state, status) {
            state.loading = status
        },
        setDialogVisible(state, status) {
            state.dialogVisible = status;
        },
        setExpenses(state, data) {
            state.expenses = data;
        },
        setExpense(state, data) {
            state.expense = data;
        },
        setExpensePayments(state, data) {
            state.payments = data;
        },
        setErrors(state, errors) {
            state.errors = errors
        },
        hasErrors(state, val) {
            state.has_errors = val
            if (!val) {
                state.errors = {
                    data: {
                        errors: {
                            expense_type_id: [],
                            amount: [],
                            effective_date: [],
                            project_id: []
                        }
                    }
                };
            }
        }
    },
    actions: {
        openDialogVisible({commit}, status) {
            commit('setDialogVisible', status);
        },

        async createExpense({dispatch, commit}, data) {
            try {
                commit('hasErrors', false)
                await api.createExpense(data);
                ElMessage.success('Expense created successfully!');
            } catch (e) {
                commit('hasErrors', true)
                commit('setErrors', e.response)
                ElMessage.error(e.response.data.message);
            }
        },

        async getExpenses({commit}, filters) {
            try {
                commit('setLoading', true)
                commit('activateLoading', 'user/list', {root: true});
                const response = await api.getExpenses(filters);
                commit('setExpenses', response);
                commit('setLoading', false)
                commit('deactivateLoading', 'county/list', {root: true});
            } catch (e) {
                commit('setLoading', false)
                ElMessage.error(e.response.data.message);
            }
        },
        async getExpense({commit}, filters) {
            try {
                commit('activateLoading', 'user/list', {root: true});
                const response = await api.getExpense(filters);
                commit('setExpense', response?.data);
                commit('deactivateLoading', 'county/list', {root: true});
            } catch (e) {
                ElMessage.error(e.response.data.message);
            }
        },
        async getExpensesForTenancy({commit}, filters) {
            try {
                commit('activateLoading', 'user/list', {root: true});
                const response = await api.getExpensesForTenancy(filters);
                commit('setExpenses', response);
                commit('deactivateLoading', 'county/list', {root: true});
            } catch (e) {
                ElMessage.error(e.response.data.message);
            }
        },
        async getExpensePayments({commit}, filters) {
            try {
                commit('setExpensePayments', {data: [], current_page: 1, total: 0, per_page: 10})
                commit('activateLoading', 'user/list', {root: true});
                const response = await api.getExpensePayments(filters);
                commit('setExpensePayments', response);
                commit('deactivateLoading', 'county/list', {root: true});
            } catch (e) {
                ElMessage.error(e.response.data.message);
            }
        },
        async getExpensesWithPayments({commit}, filters) {
            try {
                commit('activateLoading', 'expense_type/list', {root: true});
                const response = await api.getExpensesWithPayments(filters);
                commit('setExpenses', response);
                commit('deactivateLoading', 'expense_type/list', {root: true});
            } catch (e) {
                ElMessage.error(e.response.data.message);
            }
        },

        async createExpenses({dispatch, commit}, data) {
            try {
                commit('setLoading', true)
                commit('hasErrors', false)
                await api.createExpense(data);
                dispatch('getExpenses', {
                    paginate: true
                })
                ElMessage.success('Expense created successfully!');
                commit('setLoading', false)
                commit('setDialogVisible', false)
            } catch (e) {
                commit('setLoading', false)
                commit('hasErrors', true)
                commit('setErrors', e.response.status === 422 ? e.response : {
                    data: {
                        errors: {
                            expense_type_id: [],
                            amount: [],
                            effective_date: [],
                            project_id: []
                        }
                    }
                })
                ElMessage.error(e.response.data.message);
            }
        },
        async editExpense({dispatch, commit}, data) {
            try {
                commit('setLoading', true)
                commit('hasErrors', false)
                await api.editExpense(data);
                dispatch('getExpenses', {
                    paginate: true
                });
                ElMessage.success('Expense updated successfully!');
                commit('setLoading', false)
                commit('setDialogVisible', false)
            } catch (e) {
                commit('setLoading', false)
                commit('setErrors', e.response.status === 422 ? e.response : {
                    data: {
                        errors: {
                            expense_type_id: [],
                            amount: [],
                            effective_date: [],
                            project_id: []
                        }
                    }
                })
                commit('hasErrors', true)
                ElMessage.error(e.response.data.message);
            }
        },

        async deleteExpense({dispatch, commit}, data) {
            try {
                commit('setLoading', true)
                await api.deleteExpense(data);
                dispatch('getExpenses', {
                    paginate: true
                });
                ElMessage.success('Expense removed successfully!');
            } catch (e) {
                commit('setLoading', false)
                ElMessage.error(e.response.data.message);
            }
        },

        async exportExpensesReport({commit}, {filters, format}) {
            try {
                commit('setLoading', true);
                let fileName = new Date().toISOString().slice(0, 10).replaceAll("-", "_") + "_" + new Date().toLocaleTimeString();
                const response = await api.exportExpensesReport({...filters, format});
                const url = window.URL.createObjectURL(new Blob([response]))
                const link = document.createElement('a')
                link.href = url
                link.setAttribute('download', 'Expenses_Report_' + fileName + '.' + format);
                document.body.appendChild(link);
                link.click();
                commit('setLoading', false);
            } catch (e) {
                commit('setLoading', false);
                if (e.response.status === 422) {
                    ElMessage.error("Whoops! You have insufficient permissions to perform this action.");
                } else {
                    ElMessage.error(e.response.data.message);
                }
            }
        },


    }
}
